import React, { Component } from 'react'

class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = { name: '', email: '', message: '', submitted: false, loading: false };
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    const { name, email, message } = this.state;
    if (!email || !message) return;

    this.setState({ loading: true });
    try {
      await fetch('https://lama.fetchy.vet/api/newsletter/contact/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, email, message }),
      });
      this.setState({ submitted: true });
    } catch (err) {
      // silently fail
    }
    this.setState({ loading: false });
  }

  render() {
    const { name, email, message, submitted, loading } = this.state;

    return (
      <section className="vt-section dark" id="contact">
        <div className="vt-shell grid2" style={{ alignItems: 'flex-start', gap: 56 }}>
          <div>
            <span className="eyebrow" style={{ color: 'var(--pastel-mint)' }}>Mot doux</span>
            <h2 style={{ color: '#fff' }}>Écris-nous.</h2>
            <p style={{ opacity: .72, color: '#fff' }}>
              Une remarque constructive, une question, une idée ? Laisse-nous un mot, on te répond dès que possible.
            </p>

            {submitted ? (
              <p style={{ color: 'var(--pastel-mint)', fontSize: 16, marginTop: 20 }}>
                Merci ! On te répond vite.
              </p>
            ) : (
              <form onSubmit={this.handleSubmit}>
                <div className="grid2" style={{ gap: '0 14px', marginTop: 8 }}>
                  <input className="field" name="name" value={name} onChange={this.handleChange} placeholder="Nom" />
                  <input className="field" type="email" name="email" value={email} onChange={this.handleChange} placeholder="Email" required />
                </div>
                <textarea className="field" name="message" rows="4" value={message} onChange={this.handleChange} placeholder="Message" required style={{ marginTop: 14 }}></textarea>
                <button type="submit" className="vt-btn vt-btn-call vt-btn-lg" style={{ marginTop: 16 }} disabled={loading}>
                  {loading ? 'Envoi…' : 'Envoyer'}
                </button>
              </form>
            )}
          </div>
          <div style={{ paddingTop: 36 }}>
            <h5 style={{ color: 'rgba(255,255,255,.5)', textTransform: 'uppercase', letterSpacing: '.14em', fontSize: 12 }}>Adresse</h5>
            <p style={{ color: '#fff', opacity: .9, margin: '8px 0 24px' }}>
              <i data-lucide="map-pin" style={{ verticalAlign: -3 }}></i>{' '}
              44 Woodland Rise, London N10 3UG
            </p>
            <a href="#mentions" style={{ display: 'inline-block', marginTop: 24, color: 'rgba(255,255,255,.6)', fontSize: 13 }}>
              Mentions légales
            </a>
          </div>
        </div>
      </section>
    )
  }
}

export default Contact;
